
<template>
  <div id="activityCalendar">
    <!--Card-->
    <div class="card">
      <!--Card content-->
      <div class="card-block">
        <!--Title-->
        <button class="closeButton" v-if="showCloseButton" @click="toggleCalendarOnTop()">
          <i class="fa fa-times-circle" aria-hidden="true"></i>
        </button>
        <h4 class="card-title text-sm-center m-b-2">{{t('Calendar')}}</h4>
        <!--Text-->
        <div class="row">
          <div class="col-sm-12">
            <div id="calendar"></div>
          </div>
        </div>
        <pre-booking></pre-booking>
      </div>
      <!--/.Card content-->

    </div>
    <!--/.Card-->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import fullCalendar from 'fullcalendar'; // eslint-disable-line
import PreBooking from './PreBooking'; // eslint-disable-line

const $ = window.$;
let calendar;

export default {
  name: 'ActivityCalendar',
  components: {
    'pre-booking': PreBooking,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
      language: state => state.language,
      calendar: state => state.publicCalendar.calendar,
    }),
  },
  watch: {
    calendar(newVal) {
      if (typeof calendar !== 'undefined') {
        calendar.fullCalendar('removeEvents');
        calendar.fullCalendar('addEventSource', { events: newVal });
        // calendar.fullCalendar('refetchEventSources', { events: this.activities });
        // calendar.fullCalendar('render');
      }
    },
  },
  props: {
    activityId: { default: undefined },
    startDate: { default: undefined },
    endDate: { default: undefined },
    showCloseButton: { default: false },
  },
  methods: {
    ...mapActions({
      getActivityCalendar: 'publicCalendar/getCalendarForActivity',
      getAvailableTimes: 'publicCalendar/getAvailableTimes',
      toggleCalendarOnTop: 'activityUI/toggleCalendarOnTop',
    }),
    renderCalendar() {
      const self = this;
      calendar =
      $('#calendar').fullCalendar({
        header: {
          left: 'prev',
          center: 'title',
          right: 'next',
        },
        navLinks: false,
        fixedWeekCount: false,
        allDayText: this.$store.state.locales[this.language].allDayText,
        dayNamesShort: this.$store.state.locales[this.language].weekdaysShort,
        dayNames: this.$store.state.locales[this.language].weekdays,
        monthNamesShort: this.$store.state.locales[this.language].monthNamesShort,
        monthNames: this.$store.state.locales[this.language].monthNames,
        buttonText: this.$store.state.locales[this.language].calendarButtons,
        timeFormat: 'H:mm',
        height: 650,
        events(start, end, timezone, callback) {
          self.getActivityCalendar({ activityId: self.activityId, startDate: start.subtract(70, 'days').format('YYYY-MM-DD'), endDate: end.add(70, 'days').format('YYYY-MM-DD') });
          callback(this.activities);
        },
        viewRender(view) {
          const now = new Date();
          const end = new Date();
          end.setMonth(now.getMonth() + 24); // Adjust as needed

          if (end < view.end) {
            $('#calendar .fc-next-button').hide();
          } else {
            $('#calendar .fc-next-button').show();
          }

          if (view.start < now) {
            $('#calendar .fc-prev-button').hide();
          } else {
            $('#calendar .fc-prev-button').show();
          }
          self.$emit('renderedCalendar');
        },
        eventClick(event) {
          const selectedDay = event.start.format('YYYY-MM-DD');
          $('.fc-day-top').removeClass('selected');
          $(`.fc-day-top[data-date="${selectedDay}"]`).addClass('selected');
          self.getAvailableTimes(selectedDay);
        },
      });
    },
  },
  mounted() {
    window.addEventListener('resize', this.renderCalendar);
    this.renderCalendar();
  },
  beforeUpdate() {
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.renderCalendar);
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables-b4"; /* for $brand-primary */
@import "../../../static/MDB-PRO/sass/mdb/free/data/colors";
@import "../../assets/scss/variables";
/* 1.  ALL SCREENS*/
.card {
  min-height: 70vh;
  margin-bottom: 0;
}

.closeButton {
  position: absolute;
  top: 0;
  right: 8px;
  font-size: 36px;
  color: #ff4444;
  border: 0;
  background-color: transparent;
}

/* Small Screen 544px */
@media only screen and (min-width: map-get($grid-breakpoints, sm)) {

}

/* Small Devices, Tablets 768px */
@media only screen and (min-width: map-get($grid-breakpoints, md)) {
}

/* Medium Devices, Desktops */
@media only screen and (min-width: map-get($grid-breakpoints, lg)) {
}

/* Large Devices, Wide Screens  1200px */
@media only screen and (min-width: map-get($grid-breakpoints, xl)) {

}

</style>

<style lang="scss">
/* FIND A WAY TO SCOPE THIS STYLES... THEY INTERFERE WITH OTHER ELEMENTS*/
@import "../../../static/MDB-PRO/sass/mdb/free/data/colors";
@import "../../../static/MDB-PRO/sass/mdb/free/data/mixins";
@import "../../assets/scss/variables";
@import "../../assets/scss/variables-b4"; /* for $brand-primary */
@import "../../../static/MDB-PRO/sass/mdb/free/helpers";
@import "../../../static/MDB-PRO/sass/mdb/free/global";
@import "../../../static/MDB-PRO/sass/mdb/free/buttons";
/* Button Dependencies */

@import '../../../static/js/fullcalendar/dist/fullcalendar.css';

/*Reset ActivityCalendar*/
#activityCalendar #calendar {
  .fc-toolbar > * > * {
    float: none;
  }
  td, th {
    border: 0 none;
  }
  .fc-state-highlight {
    background: transparent !important;
  }
  .fc-day-number {
    display: block;
    float: none;
    text-align: center;
    width: 100%;
    padding: 0;
    padding-top: 6px;
  }
  .fc-event {
    border: none;
    height: 0;
    margin-top: -20px;
  }
  .fc-content-skeleton {
    thead {
    }
    tbody {
      margin-top: -38px;
      position: relative;
    }
  }
  .fc-body .fc-row {
    height: 50px !important;
    min-height: 0;
  }
}


#activityCalendar #calendar {
  .fc-day-top.selected {
    color: white;
    position: relative !important;
  }
  .fc-day-top.selected:before {
    content: '';
    background: #00B48D;
    border-radius: 100px;
    display: block;
    margin-left: auto;
    margin-right: auto;
    height: 39px;
    width: 39px;
    top: 0;
    left: calc(50% - 19px);
    position: absolute;
  }
  .fc-icon-right-single-arrow:after {
    content: "\203A";
    font-weight: bold;
    font-size: 150%;
    line-height: 16px;
  }

  .fc-icon-left-single-arrow:after {
    content: "\2039";
    font-weight: bold;
    font-size: 150%;
    line-height: 16px;
  }

  .fc-view-container {
    margin-top: 24px;
  }
  .fc-week {
    height: auto !important;
  }
  .fc-event-container {
    position: relative;
  }
  .fc-event {
    // background-color: #00B48D !important;
    background-color: transparent;
    height: 24px;
    width: 24px;
    margin-left: auto;
    margin-right: auto;
    border-radius: 50%;
    top: -5px;
  }
  .fc-day-number {
    position: relative;
    z-index: 1000;
  }
  .fc-event:after {
    content: "\f111";
    font: normal normal normal 32px/1 FontAwesome;
    color: #00B48D;
    position: absolute;
    //top: -38px;
    left: 0;
    right: 0;
    opacity: 0.6;
    // text-shadow: 0 2px 10px rgba(0, 0, 0, 0.4);
  }
  .fc-event.oldOccurrence:after {
    color: #777;
  }
  .fc-event:hover:after {
    opacity: 1;
  }
  .fc-day-number {
    pointer-events: none;
  }
  .fc-day-top {
    height: 0;
  }
  .fc-content-skeleton {
    position: relative;
    tbody {
      tr {
        position: relative;
        margin-top: -100px;
        height: 0px;
      }
      .fc-event-container {
        min-height: 40px;
        width: 14.285%;
        text-align: center;
        margin-left: -10px;
        height: 0;

          .fc-event {
            line-height: 0;
          }
      }
    }
  }
}

#calendar {
  table {
    width: 100%;
  }

  .fc-toolbar {
    margin-bottom: 0;
  }
  .fc-day-number, .fc-day-header {
    width: calc(100% / 7);
    text-align: center;
  }
  .fc-scroller {
    height: auto !important;
    overflow: hidden !important;

  }
  .fc-center {
    width: 100%;
    text-align: center;
      .btn {
        float: none;
      }
  }
  .fc-right {
    text-align: center;
    width: 100%;
  }
  .fc-today {
    font-weight: 500;
  }
  .fc-past {
    opacity: 0.4;
  }
  .fc-button {
    @extend .btn;
    @extend .btn-default;
    padding: 6px 18px;
  }
  .fc-day-top {
    width: 14.285%;
    text-align:center;
  }
  .fc-today {
    position:relative;
    z-index: 2;
  }
  /*
     .fc-today:before {
       display: block;
       position: absolute;
       top: 0;
       left: 50%;
       margin-left: -12px;
       border-radius: 100%;
       content: '';
       width: 26px;
       height: 26px;
       background-color: rgba($brand-primary, 0.15);
       z-index: 1;
     }*/
  .fc-button {
    background-color: $brand-primary;
  }
  .fc-left {
    text-align: center;
  }
  .fc-button-group {
    position: relative;
    width: 100%;
  }
  .fc-prev-button {
    position: absolute;
    left: -25px;
    top: -5px;
  }
  .fc-next-button {
    position: absolute;
    top: -5px;
    right: -25px;
  }
}

/* Large Devices, Wide Screens  1200px */
@media only screen and (min-width: map-get($grid-breakpoints, xl)) {
  #calendar {
     $btnWidth: 45px;
    .fc-next-button {
      min-width: $btnWidth;
      right: 0;
    }
    .fc-prev-button {
      min-width: $btnWidth;
      left: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ActivityCalendar.vue?1e63165e